export default "__VITE_ASSET__Cn0gMGHT__"